import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { VirtualAccountListItem } from '@/api/virtualAccounts';
import { StatusChip } from '@/components/StatusChip';

interface ArchivedVirtualAccountCardProps {
  virtualAccount: VirtualAccountListItem;
  onRestore: () => void;
  disabled?: boolean;
}

/**
 * An ARCHIVED owned virtual account on the list (MM-D-62): dimmed with secondary ink (no new color,
 * nothing outside the audit), links nowhere, and offers Restore only.
 */
export function ArchivedVirtualAccountCard({
  virtualAccount,
  onRestore,
  disabled = false,
}: ArchivedVirtualAccountCardProps) {
  const { t } = useTranslation();
  const counts = t('virtualAccounts.counts', {
    sharers: t('virtualAccounts.sharerCount', { count: virtualAccount.shareCount }),
    envelopes: t('virtualAccounts.envelopeCount', { count: virtualAccount.envelopeCount }),
  });
  return (
    <Card elevation={1} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flex: 1 }}>
        <Typography
          variant="h3"
          component="h3"
          noWrap
          gutterBottom
          sx={{ color: 'text.secondary' }}
        >
          {virtualAccount.name}
        </Typography>
        <Box sx={{ mb: 1 }}>
          <StatusChip domain="virtualAccount" status="ARCHIVED" />
        </Box>
        <Typography variant="body2" component="div">
          {counts}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" variant="outlined" onClick={onRestore} disabled={disabled}>
          {t('virtualAccounts.restore')}
        </Button>
      </CardActions>
    </Card>
  );
}
